import { v4 as uuid } from 'uuid';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { DOC_TYPES, base64ToBlob, useStores } from '~/utils';
import OnboardingDocPhotoBack from './OnboardingDocPhotoBack';

const OnboardingDocPhotoBackContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const handleSubmit = async (image: string) => {
    const docType =
      user.selectedDocumentType === DOC_TYPES.IDENTITY_CARD_FRONT
        ? DOC_TYPES.IDENTITY_CARD_REAR
        : DOC_TYPES.DRIVER_LICENSE_REAR;

    const blob = base64ToBlob(image);

    const picture = {
      uri: image,
      name: `${uuid()}.jpg`,
      mimeType: 'image/jpeg',
      type: docType,
      size: blob.size,
      blob: blob,
    };

    await user.userImageValidation(picture);
    navigate(Routes.ONBOARDING_CONTRACT);
  };
  return <OnboardingDocPhotoBack handleSubmit={handleSubmit} />;
};

export default observer(OnboardingDocPhotoBackContainer);
